import React from 'react';

const MainPage = ({ children }) => {
  return (
    <main className="min-h-[calc(100vh-140px)] bg-slate-50">
      <div>{children}</div>
    </main>
  );
};

export default MainPage;
